<template>
  <el-container  class="height100">
    <el-container class="height100 userDetail width100" ref="userDetail">
      <el-main class="el-mainContent padding0 overflowYHidden userDetailMain normalHeight" >
        <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight" ref="normalheader">
          <el-col :span="12"  class="normalLineH">{{$t('user_info')}}</el-col>
          <el-col :span="12" class="align-right normalLineH">
            <el-button type="primary" plain @click="$emit('exit')" size="small">{{$t('back')}}</el-button>
            <el-button type="primary" @click="onSaveBtnClick('back')" size="small" plain>{{$t('saveAndBack')}}</el-button>
            <el-button type="primary" @click="onSaveBtnClick('new')" size="small" plain v-if="!isOpen || (isOpen && isAdmin) || (isOpen && !isSecret)">{{$t('saveAndNew')}}</el-button>
            <el-button type="primary" @click="onSaveBtnClick('no')" size="small">{{$t('save')}}</el-button>
            
          </el-col>
        </el-row>
      </el-main>
        <!-- 用户详情 -->
        <el-form
          ref="form"
          :model="content"
          label-position="top"
          label-width="180px"
          size="small"
          :rules="rules"
          class="user-form paddingLeft0 "
          
        >
          <p class="smallHeader">{{$t('baseInfo')}} </p>
          <!-- (ID: {{content.id}}) -->
          
          <el-row>
            <el-col :span="10">
              <el-form-item label="手机号" prop="loginno"  class="padding0Label">
                <!-- <el-input   type="text" @change="mouseleaveLoginno" style="width: 60%" v-model="content.loginno"  :disabled="!isNew" @blur="handleBlur"></el-input> -->
                <el-input   type="text" style="width: 60%" v-model="content.loginno"  :disabled="!isNew" @blur="handleBlur"></el-input>
                <el-button v-if="!isNew" class="marginLeft10" @click="changeLoginNo">变更</el-button>
              </el-form-item>
              
            </el-col>
            <el-col :span="6" :offset="2" style="display:none">
              <el-form-item :label="$t('password')" prop="loginpwd"  class="padding0Label" >
                <el-input type="password" v-model="content.loginpwd"  @change="changePwd" :disabled="(isOpen && isAdmin) || (isOpen && !isSecret) "></el-input>
              </el-form-item>              
            </el-col>

            <el-col :span="6" :offset="2" v-if="content.id">
              <el-form-item :label="$t('password')" class="padding0Label" >
                <el-button @click="restpwd">重置密码</el-button>
                <p style="color:red;line-height:20px" v-if="resetFlag">重置密码已确定，请点击右上角【保存】按钮保存信息即可生效，若不保存信息则不生效！</p>
              </el-form-item>              
            </el-col>
            
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="姓名" prop="name"  class="padding0Label">
                <el-input type="text" v-model="content.name" :disabled="disabledInput||(isOpen && !isAdmin) || (isOpen && isSecret) || (content.field13=='已认证')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="6">
              <el-form-item :label="$t('orderByNo')"  class="padding0Label">
                <el-input type="number" v-model="content.orderByNo" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "></el-input>
              </el-form-item>
              
            </el-col>
          </el-row>

          <el-row>
            <!-- <el-col :span="6">
              <el-form-item :label="$t('tel') + '1'" class="padding0Label">
                <el-input type="text" v-model="content.telephone"
                  :active-value="true"
                  :inactive-value="false" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) ">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item   class="paddingLeft padding0Label" >
                {{$t('public')}}
                <el-switch v-model="content.telephonePublic" class="marginLeft2"  :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "></el-switch>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item :label="$t('email')"  class="padding0Label">
                <el-input type="text" v-model="content.email"  :disabled="disabledInput|| (isOpen && !isAdmin) || (isOpen && isSecret) "></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="2" >
              <el-form-item  class="paddingLeft padding0Label">
                {{$t('public')}}
                <el-switch v-model="content.emailPublic"
                  :active-value="true"
                  :inactive-value="false"  class="marginLeft2" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "></el-switch>
              </el-form-item>
            </el-col> -->
            <el-col :span="6" :offset="6">
              <el-form-item label="上级用户"   class="padding0Label ">
                <el-select :value="content.superior?content.superior.name:''"
                           :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "
                clearable :placeholder="$t('placeholder_select')"
                @clear="onClearSuperiorBtn"
                @focus="onFocusBtn"
                :popper-append-to-body="false"
                class="selectOptHide width100">
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item  class="paddingLeft padding0Label marginTop32">
                <el-button @click="onSuperiorUserBtnClick" class="chooseBtn" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) ">
                  <i class="el-icon-user"></i>
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" v-if='!flag' >
              <el-form-item label="是否组织管理员"   class="padding0Label padding0Switch" >
                <el-switch v-model="content.domainUser"  active-value="true"  inactive-value="false" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="!flag?6:0">
              <el-form-item label="通讯录是否显示该用户" class="padding0Label padding0Switch">
                <el-switch
                    :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "
                  v-model="content.permissionType"
                  active-value="public"
                  inactive-value="private"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('tel') + '2'" class="padding0Label">
                <el-input type="text" v-model="content.telephone2" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item  class="paddingLeft padding0Label">
                {{$t('public')}}
                <el-switch v-model="content.telephonePublic2"
                  :active-value="true"
                  :inactive-value="false"  class="marginLeft2" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "></el-switch>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- 部门及角色 -->
           <p class="smallHeader">部门及角色</p>
            <el-row>
              <el-col :span="10" class="userDeptRole">
                <el-form-item :label="deptRoleList.length!=0?'':'请点击添加部门按钮进行设置'" prop="dept"  class="padding0Label">
                  <div class="add-dept-btn" v-if="deptRoleList.length==0">
                    <el-button
                      size="small"
                      @click="onAddRoleBtnClick"
                    >
                      {{$t('add_dept')}}
                    </el-button>
                  </div>
                  <el-tabs
                  v-model="editableTabsValue"
                  type="card"
                  closable
                  @tab-remove="removeTab"
                  :class="deptRoleList.length==0?'noDept':''"
                  >
                    <el-tab-pane
                      v-for="(item) in deptRoleList"
                      :key="item.departmentId"
                      :label="item.departmentName"
                      :name="item.departmentId"
                    >
                      <el-button @click='setDefaultDept(item.departmentId)'>{{$t('setDefault')}}</el-button>
                      <el-button @click='setRole(item.departmentId)'  :disabled="(isOpen && isAdmin) ">{{$t('setRole')}}</el-button>

                      <div v-for="(ite) in item.applicationData" :key="ite.applicationId" class="userDetailRoleTag">
                        <div>{{ite.applicationName}}</div>
                        <el-tag
                          v-for="tag in ite.roleData"
                          :key="tag.roleId"
                          :closable="(isOpen && !isAdmin) || !isOpen"
                          type=""
                          @close="deleteRole(item.departmentId,ite.applicationId,tag.roleId)"

                          >
                          {{tag.roleName}}
                        </el-tag>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="2" v-if="kmShow">
                <el-form-item :label="$t('kmSetting')"  class="padding0Label">
                  <div style="margin-bottom: 20px;">
                    <el-checkbox-group v-model="kmCheckRole">
                      <el-checkbox
                        v-for="(role) in kmData"
                        closable
                        :disable-transitions="false"
                        :key="role.id"
                        :label="role.id"
                        :disabled="(isOpen && isSecret) "
                      >{{role.name}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          
          <p class="smallHeader">代理设置</p>
          <!-- <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('calendar')" prop="calendarType"  class="padding0Label">
                <el-select v-model="content.calendarType" :placeholder="$t('placeholder_select')" class="el-select-w" :popper-append-to-body="false" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) ">
                  <el-option
                    v-for="cld in calendars"
                    :key="cld.id"
                    :label="cld.name"
                    :value="cld.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('proxyUser')"  class="padding0Label">
                <!-- <el-input
                  type="text"
                  :disabled="true"
                  :value="content.proxyUser?content.proxyUser.name:''"
                ></el-input> -->
                <el-select :value="content.proxyUser?content.proxyUser.name:''"
                           :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "
                clearable :placeholder="$t('placeholder_select')"
                @clear="onClearProxyUserBtn"
                @focus="onFocusBtn"
                :popper-append-to-body="false"
                class="selectOptHide width100">
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item   class="paddingLeft padding0Label marginTop32">
                <el-button @click="onProxyUserBtnClick"  class="chooseBtn" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) ">
                  <i class="el-icon-user"></i>
                </el-button>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="4">
              <el-form-item :label="$t('description')"  class="padding0Label">
                <el-input type="textarea" v-model="content.remarks" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('startProxyTime')" class="padding0Label">
                <el-date-picker
                    :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) || !haveProxy"
                  v-model="content.startProxyTime"
                  type="datetime"
                  :placeholder="$t('datetime')"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  class="el-select-w"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="6">
              <el-form-item :label="$t('endProxyTime')" class="padding0Label">
                <el-date-picker
                    :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) || !haveProxy"
                  v-model="content.endProxyTime"
                  type="datetime"
                  :placeholder="$t('datetime')"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
         
          <!-- <el-row>
            <el-col :span="6" >
              <el-form-item :label="$t('useIM')"  class="padding0Label padding0Switch">
                <el-switch v-model="content.useIM"  :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="6">
              <el-form-item :label="$t('dimission')"  class="padding0Label padding0Switch">
                <el-switch
                  v-model="content.dimission"
                  :active-value="0"
                  :inactive-value="1"
                  :disabled="(isOpen && isAdmin)|| (isOpen && !isSecret)  "
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="6" >
              <el-form-item :label="$t('status')"  class="padding0Label padding0Switch">
                <el-switch
                  v-model="content.status"
                  :active-value="1"
                  :inactive-value="0"
                  :disabled="(isOpen && isAdmin)|| (isOpen && !isSecret)  "
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row> -->

          <p class="smallHeader">登录设置</p>
          <el-row>
            <!-- <el-col :span="6">
              <el-form-item :label="$t('liaisonOfficer')"  class="padding0Label padding0Switch">
                <el-switch v-model="content.liaisonOfficer" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) "></el-switch>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="登录异常是否锁定"   class="padding0Label padding0Switch">
                <el-switch
                  v-model="content.lockFlag"
                  :active-value="0"
                  :inactive-value="1"
                  :disabled="(isOpen && isAdmin) || (isOpen && !isSecret) "
                ></el-switch>
              </el-form-item>
            </el-col>

          </el-row>

          <!-- 更多信息 -->
          <p class="smallHeader" v-if="fieldextends.length>0">{{$t('moreInfo')}}</p>
          <div class="extendFlex">
            <div class="extend" v-for="(elm,index) in fieldextends" :key="index">
                <div v-if="elm.type=='string'"  class="padding0Label">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-input type="text" v-model="content[elm.name]" :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) || elm.isReadonly || disabledInput" style="width:50%"></el-input>
                </div>
                <div v-if="elm.type=='date'"  class="padding0Label" style="width:220px">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-date-picker
                    :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) || elm.isReadonly || disabledInput"
                    v-model="content[elm.name]"
                    type="date"
                    :placeholder="$t('datetime')"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    >
                  </el-date-picker>
                </div>
                <div v-if="elm.type=='upload'" class="padding0Label">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <div v-if="content[elm.name]">
                    <div class="pic-list"
                      style="float:left"
                      @mouseover="changeActive(index)"
                      @mouseout="removeActive"
                    >
                      <div class="slider-list">
                          <img :src="content[elm.name]" v-if="(content[elm.name].indexOf('http://')>=0||content[elm.name].indexOf('https://')>=0)" />
                          <img :src="contextUrl + content[elm.name]" v-else/>
                      </div>
                      <transition name="fade">
                        <div class="mask" v-if="isShow && index == activeIndex">
                          <span @click="handlePictureCardPreview(content[elm.name])">
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span @click="opendialog(elm.name)" v-if="!elm.isReadonly" >
                            <i class="el-icon-delete"></i>
                          </span>
                        </div>
                      </transition>
                    </div>
                  </div>
                  <el-upload
                    :action="getFileUrl()"
                    list-type="picture-card"
                    accept="image/*"
                    name="file"
                    :data="fileData"
                    :on-success="function (file) {return fileSuccess(file,elm.name)}"
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    :style="{display:elm.isReadonly?'none':'block'}"
                    :disabled="disabledInput"
                    >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" v-if="dialogImageUrl.indexOf('http')>=0">
                    <img width="100%" :src="contextUrl + dialogImageUrl" alt="" v-else />
                  </el-dialog>
                </div>
                <div v-if="elm.type=='clob'"  class="padding0Label">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-input
                    type="textarea"
                    style="width:50%"
                    :rows="3"
                    :placeholder="$t('placeholder_enter_content')"
                    v-model="content[elm.name]"
                    :disabled="(isOpen && !isAdmin) || (isOpen && isSecret) || elm.isReadonly">
                  </el-input>
                </div>
                <div v-if="elm.type=='radio'">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-radio-group v-model="content[elm.name]" :disabled="elm.isReadonly">
                    <el-radio
                      v-for="(options,index) in elm.options"
                      :key="index"
                      :label="options.label"
                      >{{options.label}}
                    </el-radio>
                  </el-radio-group>
                </div>
                <div v-if="elm.type=='checkbox' && elm.options.length > 0">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-checkbox-group v-model="elm.checkboxList" @change="hanleChange($event,elm.name)" :disabled="elm.isReadonly">
                    <el-checkbox 
                      v-for="item in elm.options"
                      :key="item"
                      :label="item">
                      {{item}}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div v-if="elm.type=='select'"  class="padding0Label">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-select  v-model="content[elm.name]" :placeholder="$t('placeholder_select')" :disabled="elm.isReadonly||disabledInput">
                    <el-option
                      v-for="(item,index) in elm.options"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
            </div>
          </div>

        </el-form>

    </el-container>
    <role_select :visible.sync="setRoleVisiable" v-if="setRoleVisiable" :deptRoleList="changeDeptRoleList" />
    <user_selectbox :detail="paramcontent" :visible.sync="userSelectVisible" v-if="userSelectVisible" @select-ok="onSelectUserOk"  />
    <department_select :visible.sync="departmentSelectVisible" :invalid="invalid" @select-ok="onSelectDepartmentOk" :departments="deptRoleList" :onedepart="onedepart"/>
     <loginno_select
          :loginnoVisible="loginnoVisible"
          v-if="loginnoVisible"
          :oldLoginNo="content.loginno"
          @updateLoginNo="updateLoginNo"
          @closeLoginNo="loginnoVisible=false"
          />
  </el-container>
</template>

<script>
import role_select from "@/components/role_select.vue";

import user_selectbox from "@/components/user_selectbox.vue";
import department_select from "@/components/department_select.vue";
import loginno_select from "@/components/loginno_select.vue";
import contextPath from "@/contextPath.js"
export default {
  components: {
    role_select,
    user_selectbox,
    department_select,
    loginno_select
  },
  props: ["detail"],
  computed:{

      },
  data() {
    return {
      flag:localStorage.getItem("isDeparmentAdminRole")=="false"?false:true,
      contextPath:this.$api.getContextPath(),
      contextUrl:this.$api.getContextPath().replace(/\/api/,""),
      staticPath: this.$api.getStaticPath(),
      searchdata: {
        domainid: this.$route.query.domainid,
        departmentid: "",
        currpage: 1,
        pagelines: 20,
        orderby: "",
        data:{
          name: "",
          loginno: "",
          superiorname: "",
          roleid: "",
        }
      },
      content: {}, //部门信息对象
      userSelectVisible: false,
      currentEditField: "", //PROXY
      calendars: [], //用户可用的工作日历
      tableData: [],
      showmode: "LIST", //LIST 或 DETAIL，默认为LIST
      tabIndex:0,
      editableTabs:[],
      editableTabsValue:"",
      departmentSelectVisible:false,
      addDept:{},
      departments:[],
      kmRole:[],
      imgBase:'',
      kmData:[
        {
            "id": "0001",
            "levels": 0,
            "name": this.$t('staff')
        },
        {
            "id": "0010",
            "levels": 10,
            "name": this.$t('dept_know_manager')
        },
        {
            "id": "0020",
            "levels": 20,
            "name": this.$t('committee_know_manager')
        },
        {
            "id": "0100",
            "levels": 10,
            "name": this.$t('enterprise_know_manager')
        }
      ],
      kmCheckRole:[],
      rules:{
        name:[
          {required: true, message: '用户名称不能为空', trigger: 'blur'},
        ],
        loginno:[
          {required: true, message: '账号不能为空', trigger: 'blur'},
        ],
        // loginpwd:[
        //   {required: true, message: '密码不能为空', trigger: 'blur'},
        // ],
        calendarType:[
          {required: true, message: '日历不能为空', trigger: 'blur'},
        ],
        dept:[
          {required: true, message: '部门不能为空', trigger: 'blur'},
        ]
      },
      fieldextends:[],
      first:true,
      pwdPre:"",
      password:"888888qqqq",
      dialogImageUrl: '',
      dialogVisible: false,
      invalid:true,
      options:[],
      radioValue:'',
      selectValue:'',
      paramcontent: {},
      customApps:[],
      customAppsRole:[],
      defaultRole:[],
      haveProxy:false,
      kmShow:false,
      isAllRight:true,
      setRoleVisiable:false,
      deptRoleList:[],
      changeDeptRoleList:[],
      uploadUrl:"/authtime/uploads",
      filePath: "/uploads/lib/img",
      fileData:{
        path:'/uploads/lib/img',
        filePath:'/uploads/lib/img',
      },
      isShow:false,
      activeIndex:-1,
      isOpen:false,//开关是否开启
      isAdmin:false,//是否是系统管理员
      isSecret:false,//是否是安全保密员
      loginnoVisible: false, // 账号变更弹窗
      isNew: true,
      resetFlag:false,//默认没重置密码
      onedepart:1,//只能添加一个部门标识符
      disabledInput:false,//默认不禁用输入框，只有手机号获取到该用户信息，才禁用输入框
      btnLoading: false, // 按钮的加载中
    };
  },
  created() {
    console.log(this.$store.state.currentUser)
    if(this.$store.state.currentUser.isOpenSecurity) {
      this.isOpen=true;
      if (this.$store.state.currentUser.type == 'admin') {
        this.isAdmin = true;//是否是系统管理员
      }else if (this.$store.state.currentUser.type == 'secret') {
        this.isSecret= true;//是否是系统管理员
      }
    }else{
      this.isOpen=false;
    }
    let that=this;
    this.getCustomApp();
    this.getKmStatus();
    this.content=JSON.parse(JSON.stringify(this.detail));
    if(this.content.loginno){
      this.isNew = false;
    }
    if(this.content.proxyUser){
      this.haveProxy=true;
    }else{
      this.haveProxy=false;
    }
    this.content.startProxyTime= this.content.startProxyTime? this.resolvingDate(this.content.startProxyTime):"";
    this.content.endProxyTime= this.content.startProxyTime? this.resolvingDate(this.content.endProxyTime):"";

    this.pwdPre=this.content.loginpwd;
    if(this.content.id){//编辑用户详情页面
      this.getKmRole();
    }
    let dataJson={
      currpage:1,
      pagelines:30,
      data:{
        type:"",
        fortable:"tableUser",
        domainid: this.$route.query.domainid,
        belong:"All"
      }
    }
    this.$api.getFieldExtends(
     dataJson,
      {
        onSucess: resp => {
          resp.data.data.datas.forEach( elm => {
            if(elm.type == "radio" || elm.type == "select" || elm.type == "checkbox"){
              let option = elm.options.split(";");
              let arr = [];
              if(elm.type == "radio" || elm.type == "select"){
                for(let i=0;i<option.length;i++){
                  let obj = {}
                  obj.label = option[i];
                  obj.value = option[i];
                  arr.push(obj);
                }
                elm.options = arr;
              }else if(elm.type == "checkbox"){
                elm.checkboxList = this.content[elm.name].split(";");
                elm.options = option;
              }
            }
            that.fieldextends.push(elm)
          })
        }
      }
    );
    this.getCalendars();
    //传给子组件user_select的参数
    this.paramcontent.domainsId = this.$route.query.domainid;
    this.paramcontent.customAppsId = "";
    this.paramcontent.tabVisible = false;
    //this.searchTableData();
  },
  mounted(){
    this.$refs.form.$el.style.height=this.$refs.userDetail.$el.getClientRects()[0].height-this.$refs.normalheader.$el.getClientRects()[0].height-1+"px";

  },
  methods: {
    restpwd(){//重置密码 手机号后6位
       const h = this.$createElement;
       this.$confirm('重置密码', {
          message:h('div',[
            h('p',`${this.content.loginno}的密码将重置为初始密码：abc@${this.content.loginno.substring(this.content.loginno.length-6)}`),
            h('p',`是否确定？`),
            h('p',{style:'color:red'},`请注意：确定后，请点击右上角【保存】按钮保存信息即可生效，若不保存信息则不生效！`)
          ]),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.resetFlag=true
          this.content.loginpwd=this.processPassword(this.content.loginno.substring(this.content.loginno.length-6))
        }).catch(() => {
        });
    },
    getCalendars(){
      this.$api.getCalendars(
        { domainid: this.$route.query.domainid, currpage: "", pagelines: "",data:{ name: ""}},
        {
          onSucess: resp => {
            this.calendars = resp.data.data.datas;
            if(this.content.calendarType=="" || !this.content.calendarType){
              this.calendars.forEach(elm=>{
                if(elm.name=="标准日历"){
                  this.content.calendarType=elm.id;
                }
              })
            }

          }
        }
      );
    },
    deleteRole(deptId,applicationId,roleId){
      let index1,index2,that=this;
      this.deptRoleList.forEach((elm,ind)=>{
        if(elm.departmentId==deptId){
          index1=ind;
          elm.applicationData.forEach((el,inde)=>{
            if(el.applicationId==applicationId){
              index2=inde;
              el.roleData.forEach((elem,index)=>{
                if(elem.roleId==roleId){
                  that.deptRoleList[index1].applicationData[index2].roleData.splice(index,1);
                }
              })
            }
          })
        }
      })
    },
    setRole(id){
      let that=this;
      this.deptRoleList.forEach(elm=>{
        if(elm.departmentId==id){
          that.changeDeptRoleList=elm;
        }
      })
      this.setRoleVisiable=true;
    },
    /**
     * 复选框选中
     */
    hanleChange(val,fieldName){
      let checkboxValue = ""
      for(let i=0;i<val.length;i++){
        if(checkboxValue){
          checkboxValue = checkboxValue + ";" + val[i];
        }else{
          checkboxValue = val[i];
        }
      }
      this.content[fieldName] = checkboxValue;
    },
    fileSuccess(response, name){
      let that = this;
      let file = response.data[0];
      that.content[name] = file.filePath;
    },
    getFileUrl(){
      return this.$api.getFileUrl(this.uploadUrl+"?path="+this.filePath+"&icon=true")
    },
    changeActive(index) {
      this.activeIndex = index;
			this.isShow = true;
		},
    removeActive() {
			this.isShow = false;
		},
    /**
     * 点击预览
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    opendialog(name){
      this.content[name] = '';
    },
    getKmStatus(){
      this.$api.getKmStatus(
        { domainid: this.$route.query.domainid },
        {
          onSucess: resp => {
            this.kmShow = resp.data.data.kmstatus;
          }
        }
      )
    },
    getCustomApp(){
      let that=this;
      this.$api.getCustomAppConfig(
        { domainid: this.$route.query.domainid, data:{name: ""} },
        {
          onSucess: resp => {
            this.customApps = resp.data.data.datas;

            for (let i = 0; i < this.customApps.length; i++) {
            this.$api.getRoleList(
              { applicationid: this.customApps[i].id },
              {
                onSucess: resp => {
                  this.customApps[i].roleList = resp.data.data.role;
                  resp.data.data.role.forEach(elm=>{
                    //默认角色的获取，勿删
                    if(elm.defaultRole){
                      let val={ roleId: elm.roleId,roleName:elm.roleName, applicationId: that.customApps[i].id, departmentId:"" }
                      that.defaultRole.push(val)
                    }
                  })
                  that.$forceUpdate();
                }
              }
            );
          }
          }
        }
      )
    },
    getKmRole(){
      this.$api.getDeptUser(
        this.content.id,
        {
          onSucess: resp => {

            this.deptRoleList=resp.data.data.departmentdata;
            if(this.deptRoleList.length>0){
              for(let i=0;i<this.deptRoleList.length;i++){
                if(this.content.defaultDepartment==this.deptRoleList[i].departmentId){
                  this.deptRoleList[i].departmentName +="(默认)"
                }
                this.editableTabsValue=this.deptRoleList[i].departmentId;
                this.deptRoleList[i].title=this.deptRoleList[i].departmentName;
              }
            }
            resp.data.data.kmdata.forEach(elm=>{
              this.kmCheckRole.push(elm.id);

            })
            this.kmShow=resp.data.data.kmstatu;
          }
        }
      );
    },
    //转换参数的日期格式
    resolvingDate(date){
      let d = new Date(date);

      let month = (d.getMonth() + 1) < 10 ? '0'+(d.getMonth() + 1) : (d.getMonth() + 1);
      let day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
      let hours = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
      let min = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();

      let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;

      return times
    },
    setDefaultDept(id){
      this.content.defaultDepartment=id;
      if(this.deptRoleList.length>0){
        for(let i=0;i<this.deptRoleList.length;i++){
          if(this.content.defaultDepartment==this.deptRoleList[i].departmentId){
            if(this.deptRoleList[i].departmentName.indexOf("(默认)")==-1){
              this.deptRoleList[i].departmentName +="(默认)"
            }
            this.editableTabsValue=this.deptRoleList[i].departmentId
          }else{
            if(this.deptRoleList[i].departmentName.indexOf("(默认)")!=-1){
              this.deptRoleList[i].departmentName=this.deptRoleList[i].departmentName.substr(0,this.deptRoleList[i].departmentName.indexOf("(默认)"))
            }
          }

          this.deptRoleList[i].title=this.deptRoleList[i].departmentName;
        }
      }

    },
    onNodeClick(dept) {
      this.searchdata.departmentid = dept.id;
      this.searchTableData();
    },

    onProxyUserBtnClick() {
      this.currentEditField = "proxyUser";
      this.userSelectVisible = true;
    },

    onSuperiorUserBtnClick() {
      this.currentEditField = "superior";
      this.userSelectVisible = true;
    },

    onAddRoleBtnClick(){
      this.departmentSelectVisible=true;
    },
 /**
     * 账号变更弹窗
     */
    changeLoginNo(){
      this.loginnoVisible=true;
    },

    /**
     * 更新账号
     */
    updateLoginNo(val){
      this.content.loginno = val
    },
    onSelectUserOk(users) {
      if (users && users.length > 0) {
        if(this.currentEditField=="proxyUser"){
          this.haveProxy=true;
          this.$forceUpdate();
        }
        this.content[this.currentEditField] = users[0];
      }else if(users && users.length == 0){
        this.content[this.currentEditField]=null;
      }
    },

    onSelectDepartmentOk(role){
      let that=this;
      let length=that.deptRoleList.length;
      for(let i=0;i<role.length;i++){
        let have=false;
        for(let j=0;j<that.deptRoleList.length;j++){
          if(that.deptRoleList[j].departmentId==role[i].id){
            have=true;
            break;
          }
        }
        if(!have){
          this.addDept=role[i];
          this.addTab();
        }
      }
      if(length==0 && role.length>0 && !this.content.defaultDepartment){
        this.setDefaultDept(role[0].id)
      }
    },

    // processPassword(pw){
    //   let Base64 = require('js-base64').Base64;
    //   var str = Base64.encode(pw);
    //   if(str.length>2){
    //     var lp = str.substr(0,2);
    //     var rp = str.substr(2,str.length);
    //     pw = rp+lp;
    //   }
    //   return pw;
    // },
    //RSA加密
    processPassword(pw){      
      return this.$getCodeRSA('abc@'+pw);
    },

    changePwd(val){
      if(val!==this.pwdPre && val!="" && val){
        this.password="";
      }else{
        //如果新密码为空，也要设置为初始
        this.password="888888qqqq";
      }
    },

    mouseleaveLoginno(val){
        if(this.content.isCreate){
            this.$api.getUserByLoginno(val, {
                onSucess: resp => {
                  let data = resp.data.data;
                  if(data){
                    this.content.name = data.name;
                    this.content.loginpwd = data.loginpwd;
                    this.content.email = data.email;
                    this.content.telephone = data.telephone;
                    this.content.telephone2 = data.telephone2;
                    this.content.field1 = data.field1;
                    this.content.field2 = data.field2;
                    this.content.field3 = data.field3;
                    this.content.field4 = data.field4;
                    this.content.field5 = data.field5;
                    this.content.field6 = data.field6;
                    this.content.field7 = data.field7;
                    this.content.field8 = data.field8;
                    this.content.field9 = data.field9;
                    this.content.field10 = data.field10;
                    this.content.field11 = data.field11;
                    this.content.field12 = data.field12;
                    this.content.field13 = data.field13;
                    this.content.field14= data.field14;
                    this.content.field15 = data.field15;
                    this.content.field16 = data.field16;
                    this.content.field17 = data.field17;
                    this.content.field18 = data.field18;
                    this.content.field19 = data.field19;
                    this.content.field20 = data.field20;
                    this.content.field21 = data.field21;
                    this.content.field22 = data.field22;
                    this.content.field23 = data.field23;
                    this.content.field24 = data.field24;
                    this.content.field25 = data.field25;
                     this.$forceUpdate();
                  }
                }
            });
        }

    },

    /**
     * 账号失去焦点
     */
    handleBlur(){
      let loginNo = this.content.loginno;
      if(loginNo && this.detail.isCreate){
        this.$api.getLoginNo({ domainid: this.$route.query.domainid , loginNo},{
          onSucess: resp => {
            let data = resp.data;
            if(data.errcode == 0 && data.data){
              // this.$confirm("此账号已经在企业域（某个）存在，是否将手机、密码，邮箱带过来").then(()=>{
              //   let content = {
              //     ...this.content,
              //     ...data.data,
              //     confirmpwd: data.data.loginpwd
              //   }
              //   this.content = content;
              // }).catch(() => {});
                let content = {
                  ...this.content,
                  ...data.data,
                  confirmpwd: data.data.loginpwd
                }
                this.content = content;
                this.disabledInput=true //获取到当前手机号用户信息，禁用输入框
            }else{
                this.disabledInput=false //获取不到到当前手机号用户信息，启用输入框
            }
          }
        });
      }
    },

    // 手机号正则
    phoneReg(){
      const DLreg = /^((\+?86)|(\(\+86\)))?[1][3,4,5,6,7,8,9][0-9]{9}$/;
      const HKreg = /^((\+?852)|(\(\+852\)))([5|6|8|9])\d{7}$/;
      const AMreg = /^[0][9]\d{8}$/;
      return (DLreg.test(this.content.telephone) || HKreg.test(this.content.telephone) || AMreg.test(this.content.telephone)|| this.content.telephone2 && !(DLreg.test(this.content.telephone2) || HKreg.test(this.content.telephone2) || AMreg.test(this.content.telephone2)))
    },

    beforeUpload(file){
      let testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
      const extension = testmsg === 'jpg' ||  testmsg === 'JPG' ||  testmsg === 'png' ||  testmsg === 'PNG' || testmsg === 'jpeg' || testmsg === 'JPEG' || testmsg === 'gif' ||  testmsg === 'GIF';
      if(!extension) {
        this.$message({
          message: '上传文件只能是jpg或者png格式!',
          type: 'error'
        });
        return false;
      }
      return extension
    },

    //保存
    onSaveBtnClick(type) {
      if(!this.content.name){
        this.$message({
          showClose: true,
          message: this.$t('msg_require_name'),
          type: "error"
        });
        this.isAllRight=false;
        return false;
      }else if(this.content.name && !/^[\u4e00-\u9fa5_a-zA-Z0-9.]+$/g.test(this.content.name)){
        this.$message({
          showClose: true,
          message: this.$t('msg_special_char'),
          type: "error"
        });
        this.isAllRight=false;
        return false;
      }
      if(!this.content.loginno){
        this.$message({
          showClose: true,
          message: this.$t('msg_require_loginno'),
          type: "error"
        });
        this.isAllRight=false;
        return false;
      }
      if(this.content.loginno.length!=11){//手机号必须等于11位,尾部6位号码为密码
        this.$message({
          showClose: true,
          message: "手机号必须11位",
          type: "error"
        });
        return false;
      }
      if(parseInt(this.content.orderByNo)<0){
        this.$message({
          showClose: true,
          message: this.$t('msg_orderno_negative'),
          type: "error"
        });
        this.isAllRight=false;
        return false;
      }
      // if(!this.content.calendarType){
      //   this.$message({
      //     showClose: true,
      //     message: this.$t('msg_require_calendar'),
      //     type: "error"
      //   });
      //   this.isAllRight=false;
      //   return false;
      // }
      // if(this.content.telephone && !this.phoneReg()){//作废
      //   this.$message({
      //     showClose: true,
      //     message: this.$t('msg_tel_incorrectly'),
      //     type: "error"
      //   });
      //   this.isAllRight=false;
      //   return false;
      // }
      if(this.content.email && !(/^[a-zA-Z0-9_-]+(\+?.[a-zA-Z0-9_-]+)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/).test(this.content.email)){
        this.$message({
            showClose: true,
            message: this.$t('msg_email_incorrectly'),
            type: "error"
          });
          this.isAllRight=false;
          return false;
      }
      this.calendars.forEach(elm => {
        if(elm.id==this.content.calendarType){
          this.content.calendarTypeName=elm.name
        }
      })
      // 判断当前项是否为必填项
      let checkArr = []
      let checkTip = ""
      let have = true
      if(this.fieldextends.length > 0){
        this.fieldextends.map(item => {
          if(item.isNotNull){
            checkArr.push(item)
          }
        })
        if(checkArr.length > 0){
          checkArr.some(ele => { if(!this.content[ele.name]){
            have = false
            checkTip += ele.label + ','
          } })
        }
        if(!have){
          this.$message.error(checkTip.substring(0, checkTip.lastIndexOf(',')) + '字段为必填项')
          return false;
        }
      }
      this.content.roleDepartments=[];
      for(let j=0;j<this.deptRoleList.length;j++){
        let obj={id:this.deptRoleList[j].departmentId,name:this.deptRoleList[j].departmentName}
        this.departments.push(obj)
        for(let k=0;k<this.deptRoleList[j].applicationData.length;k++){
            for(let l=0;l<this.deptRoleList[j].applicationData[k].roleData.length;l++){
              let deptRole={"roleId":"","departmentId":"","applicationId":"","isDefaultDepartment":""}
              deptRole.departmentId=this.deptRoleList[j].departmentId;
              deptRole.applicationId=this.deptRoleList[j].applicationData[k].applicationId
              deptRole.roleId=this.deptRoleList[j].applicationData[k].roleData[l].roleId;
              if(this.deptRoleList[j].departmentId==this.content.defaultDepartment){
                deptRole.isDefaultDepartment="true"
              }else{
                deptRole.isDefaultDepartment="false"
              }
              this.content.roleDepartments.push(deptRole);
            }
        }
      }
      if(this.customApps.length==0){
        //域(租户)没有绑定软件，不需要校验软件角色
        if(this.departments.length==0){
          //没有选择部门
          this.$message({
            showClose: true,
            message: this.$t('msg_select_dept'),
            type: "error"
          });
          this.isAllRight=false;
          return false;
        }
      }else{
        //绑定软件了
        if(this.departments.length==0){
          //没有选择部门
          this.$message({
            showClose: true,
            message: this.$t('msg_select_dept'),
            type: "error"
          });
          this.isAllRight=false;
          return false;
        }
        if((!this.content.roleDepartments || this.content.roleDepartments.length==0)){
          //如果选择了部门没有选择角色
          this.$message({
            showClose: true,
            message: this.$t('msg_select_role'),
            type: "error"
          });
          this.isAllRight=false;
          return false;
        } 
      }
      if(!this.content.startProxyTime&&this.content.endProxyTime){
        this.$message({
          showClose: true,
          message: this.$t('msg_startProxyTime'),
          type: "error"
        });
        return false;
      }
      if(this.content.startProxyTime&&!this.content.endProxyTime){
        this.$message({
          showClose: true,
          message: this.$t('msg_endProxyTime'),
          type: "error"
        });
        return false;
      }
      // if(this.password!="888888qqqq" && this.content.loginpwd){
      //   //更改密码，且新密码不为空
      //   this.pwdPre=this.content.loginpwd;
      //   this.content.loginpwd=this.processPassword(this.content.loginpwd) //55
      // }
      // else if(this.password == "888888qqqq" && (this.content.loginpwd == ""|| !this.content.loginpwd)){
      //   //用户密码为空或者没有改变
      //   this.$message({
      //     showClose: true,
      //     message: this.$t('msg_require_password'),
      //     type: "error"
      //   });
      //   this.isAllRight=false;
      //   return false;
      // }
      // else{
      //   this.content.loginpwd="888888qqqq"
      // }
      if(this.content.roleDepartments.length==0 && this.departments.length!=0){
        this.content.roleDepartments=[];
        this.departments.forEach(elm=>{
          this.content.roleDepartments.push({ roleId: "", applicationId: "", departmentId: elm.id})

        })
      }
      if(this.content.defaultDepartment=="" || !this.content.defaultDepartment){
        this.$message({
          showClose: true,
          message: this.$t('msg_default_dept'),
          type: "error"
        });
        this.isAllRight=false;
        return false;
      }
      let contentSub={
          "name": this.content.name,
          "loginno": this.content.loginno,
          "domainUser":false,
          "loginpwd":"123456",
          "email": "email@teemlink.com",
          "emailPublic": true,
          "telephone": "13192286346",
          "telephonePublic": true,
          "calendarType": "i7xj207zBMEwBp8aATE",
          "calendarTypeName": "夜班日历",
          "telephone2": "13192286349",
          "telephonePublic2": true,
          "reportTree": "",
          "superiorid": "",
          "allUsers": "",
          "_proxyUser": "",
          "remarks": "1111",
          "startProxyTime": "2019-09-30 16:41:01",
          "endProxyTime": "2019-10-11 16:41:04",
          "permissionType": "public",
          "orderByNo":0,
          "lockFlag": 1,
          "dimission": 1,
          "status": 1,
          "defaultDepartment": "Z42xU8LmniRouZ93E7s",
          "_userRoleDepartmentJson": '[{"roleId":"kPLbeydkgiYW6NIkCt0","departmentId":"Z42xU8LmniRouZ93E7s","applicationId":"HdPeBqYwJyFyjHkhZu3","isDefaultDepartment":"true"}]',
          "_userKMRoleJson": '["0001"]',
        }
      if (this.content && this.content.id) {
        contentSub.id="";
        contentSub={
          "id":this.content.id,
          "name": this.content.name,
          "domainUser":this.content.domainUser?this.content.domainUser:"true",
          "ddUserId": this.content.ddUserId? this.content.ddUserId : "",
          "loginno": this.content.loginno,
          "loginpwd":this.resetFlag?this.content.loginpwd:'888888qqqq',//this.content.loginpwd
          "email": this.content.email ? this.content.email : "",
          "emailPublic": this.content.emailPublic,
          "telephone": this.content.telephone ? this.content.telephone : "",
          "telephonePublic": this.content.telephonePublic,
          "calendarType": this.content.calendarType,
          "calendarTypeName": this.content.calendarTypeName,
          "telephone2": this.content.telephone2 ?this.content.telephone2:"",
          "telephonePublic2": this.content.telephonePublic2,
          "reportTree": "",
          "superiorid": this.content.superior?this.content.superior.id:"",
          "allUsers": "",
          "liaisonOfficer":this.content.liaisonOfficer?this.content.liaisonOfficer:false,
          "superAdmin":this.content.superAdmin?this.content.superAdmin:false,
          "useIM":this.content.useIM?this.content.useIM:false,
          "_proxyUser": this.content.proxyUser?this.content.proxyUser.id:"",
          "remarks": this.content.remarks?this.content.remarks:"",
          "startProxyTime": this.content.startProxyTime?this.content.startProxyTime:"",
          "endProxyTime": this.content.endProxyTime?this.content.endProxyTime:"",
          "permissionType": this.content.permissionType?this.content.permissionType:"",
          "orderByNo":this.content.orderByNo?parseInt(this.content.orderByNo):0,
          "lockFlag": this.content.lockFlag,
          "dimission":this.content.dimission,
          "status":this.content.status,// this.content.status
          "defaultDepartment": this.content.defaultDepartment?this.content.defaultDepartment:"",
          "_userRoleDepartmentJson":this.content.roleDepartments?JSON.stringify(this.content.roleDepartments).replace(/"/g,"'"):"" ,
          "_userKMRoleJson": JSON.stringify(this.kmCheckRole).replace(/"/g,"'")?JSON.stringify(this.kmCheckRole).replace(/"/g,"'"):"",
          "field1":this.content.field1?this.content.field1:null,
          "field2":this.content.field2?this.content.field2:null,
          "field3":this.content.field3?this.content.field3:null,
          "field4":this.content.field4?this.content.field4:null,
          "field5":this.content.field5?this.content.field5:null,
          "field6":this.content.field6?this.content.field6:null,
          "field7":this.content.field7?this.content.field7:null,
          "field8":this.content.field8?this.content.field8:null,
          "field9":this.content.field9?this.content.field9:null,
          "field10":this.content.field10?this.content.field10:null,
          "field11":this.content.field11?this.content.field11:null,
          "field12":this.content.field12?this.content.field12:null,
          "field13":this.content.field13?this.content.field13:null,
          "field14":this.content.field14?this.content.field14:null,
          "field15":this.content.field15?this.content.field15:null,
          "field16":this.content.field16?this.content.field16:null,
          "field17":this.content.field17?this.content.field17:null,
          "field18":this.content.field18?this.content.field18:null,
          "field19":this.content.field19?this.content.field19:null,
          "field20":this.content.field20?this.content.field20:null,
          "field21":this.content.field21?this.content.field21:null,
          "field22":this.content.field22?this.content.field22:null,
          "field23":this.content.field23?this.content.field23:null,
          "field24":this.content.field24?this.content.field24:null,
          "field25":this.content.field25?this.content.field25:null,
        }

        this.btnLoading = true;
        this.$api.getLoginNo({ domainid: this.$route.query.domainid , loginNo: contentSub.loginno},{
          onSucess: resp => {
            let data = resp.data;
            let isSyncUser = false;
            if(data.errcode == 0 && data.data){
              // isSyncUser = confirm("此账号已经在其他域已存在，是否将手机、密码，邮箱覆盖到其余域xx（某个)");
              isSyncUser=true
            }
            this.$api.updateUser(
              {
                domainid: this.$route.query.domainid,
                userid: this.content.id,
                isSyncUser,
                data: contentSub
              },
              {
                onSucess: resp => {
                  this.btnLoading = false;
                  if (resp.data.errcode == 0) {
                    this.$message({
                      showClose: true,
                      message: this.$t('msg_save_success'),
                      type: "success"
                    });
                    this.password="888888qqqq"
                    if(type=="back"){
                      this.$emit('exit')
                    }else if(type=="new"){
                      this.content={startProxyTime:"",endProxyTime:"",status:1,permissionType:"public",roleDepartments:[], departmentUser: false};
                      this.content.status=this.content.status == true? true : false
                      this.content.permissionType=this.content.permissionType=='public'? true : false,
                      this.departments=[];
                      this.kmCheckRole = [];
                      this.deptRoleList = [];
                      this.getCalendars();
                    }else{
                      this.$emit("refresh")
                    }                    
                  } else {
                    this.content.loginpwd=this.pwdPre;
                    this.$message({
                      showClose: true,
                      message: resp.data.errmsg,
                      type: "error"
                    });
                  }
                }
              }
            );
          }
        });        
      } else { 
        //新建
        contentSub={
          "name": this.content.name,
          "loginno": this.content.loginno,
          // "loginpwd":this.content.loginpwd,//this.content.loginpwd
          "loginpwd":this.processPassword(this.content.loginno.substring(this.content.loginno.length-6)),//新建取手机后6位
          "domainUser":this.content.domainUser?this.content.domainUser:"true",
          "email": this.content.email ? this.content.email : "",
          "emailPublic": this.content.emailPublic,
          "telephone": this.content.telephone ? this.content.telephone : "",
          "telephonePublic": this.content.telephonePublic ,
          "calendarType": this.content.calendarType,
          "calendarTypeName": this.content.calendarTypeName,
          "telephone2": this.content.telephone2 ?this.content.telephone2:"",
          "telephonePublic2": this.content.telephonePublic2,
          "reportTree": "",
          "superiorid": this.content.superior?this.content.superior.id:"",
          "allUsers": "",
          "_proxyUser": this.content.proxyUser?this.content.proxyUser.id:"",
          "remarks": this.content.remarks?this.content.remarks:"",
          "startProxyTime": this.content.startProxyTime?this.content.startProxyTime:"",
          "endProxyTime": this.content.endProxyTime?this.content.endProxyTime:"",
          "permissionType": this.content.permissionType?this.content.permissionType:"",
          "orderByNo":this.content.orderByNo?parseInt(this.content.orderByNo):0,
          "lockFlag": this.content.lockFlag,
          "dimission": this.content.dimission,
          "status":this.content.status,// this.content.status
          "defaultDepartment": this.content.defaultDepartment?this.content.defaultDepartment:"",
          "_userRoleDepartmentJson":this.content.roleDepartments?JSON.stringify(this.content.roleDepartments).replace(/"/g,"'"):""  ,
          "_userKMRoleJson": JSON.stringify(this.kmCheckRole).replace(/"/g,"'")?JSON.stringify(this.kmCheckRole).replace(/"/g,"'"):"",
          "field1":this.content.field1?this.content.field1:null,
          "field2":this.content.field2?this.content.field2:null,
          "field3":this.content.field3?this.content.field3:null,
          "field4":this.content.field4?this.content.field4:null,
          "field5":this.content.field5?this.content.field5:null,
          "field6":this.content.field6?this.content.field6:null,
          "field7":this.content.field7?this.content.field7:null,
          "field8":this.content.field8?this.content.field8:null,
          "field9":this.content.field9?this.content.field9:null,
          "field10":this.content.field10?this.content.field10:null,
          "field11":this.content.field11?this.content.field11:null,
          "field12":this.content.field12?this.content.field12:null,
          "field13":this.content.field13?this.content.field13:null,
          "field14":this.content.field14?this.content.field14:null,
          "field15":this.content.field15?this.content.field15:null,
          "field16":this.content.field16?this.content.field16:null,
          "field17":this.content.field17?this.content.field17:null,
          "field18":this.content.field18?this.content.field18:null,
          "field19":this.content.field19?this.content.field19:null,
          "field20":this.content.field20?this.content.field20:null,
          "field21":this.content.field21?this.content.field21:null,
          "field22":this.content.field22?this.content.field22:null,
          "field23":this.content.field23?this.content.field23:null,
          "field24":this.content.field24?this.content.field24:null,
          "field25":this.content.field25?this.content.field25:null,
        }
        this.$api.createUser(
          { domainid: this.$route.query.domainid, data: contentSub },
          {
            onSucess: resp => {
              if (resp.data.errcode == 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('msg_save_success'),
                  type: "success"
                });
                this.password="888888qqqq"
                this.content.id=resp.data.data.id;
                if(type=="back"){
                  this.$emit('exit')
                }else if(type=="new"){
                  this.content={};
                  this.departments=[];
                  this.kmCheckRole = [];
                  this.deptRoleList = [];
                  this.getCalendars();
                }
                
              } else {
                this.content.loginpwd=this.pwdPre;
                this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
                
                
              }
            }
          }
        );
      }
    },
    onSaveClick(){
      this.saveBack=false;
      this.onSaveBtnClick();
    },
    onSaveAndBackClick(){
      this.saveBack=true;
      this.onSaveBtnClick();
    },

    onSaveAndNewClick(){
      this.onSaveBtnClick();
      if(!this.isAllRight){
        return false;
      }
      this.saveBack=false;
      this.content={};
      this.departments=[]
      this.kmCheckRole = []
      this.deptRoleList = []
    },

    searchTableData() {
      this.$api.getUsers(this.searchdata, {
        onSucess: resp => {
          this.tableData = resp.data.data.datas;
        }
      });
    },

    addTab() {
      let that=this;
      let newTabId = this.addDept.id;
      this.addDept.title=this.addDept.name;
      
      // this.departments.push(this.addDept)
      // let val={roleId: el.roleId, applicationId: el.applicationId, departmentId:that.addDept.id }
      let obj={
        "departmentName": that.addDept.name,
        "departmentId": that.addDept.id,
        "isDefaultDepartment": false,
        "applicationData":[],
      }
      this.customApps.forEach(elm=>{
        let app={
          "roleData":[],
          "applicationId":elm.id,
          "applicationName":elm.name,
        }
        that.defaultRole.forEach(el=>{
          if(el.applicationId==elm.id){
            let role={roleId:el.roleId,roleName:el.roleName}
            app.roleData.push(role)
          }
          
        })
        obj.applicationData.push(app);
      })
      this.deptRoleList.push(obj);
      this.editableTabsValue = newTabId;
    },
    onClearSuperiorBtn(){
      this.content.superior=null;
    },
    onClearProxyUserBtn(){
      this.content.proxyUser=null;
      this.haveProxy=false
    },
    onFocusBtn(){
      
    },
    removeTab(target) {
        let tabs = this.deptRoleList;
        // let targetNameId="";
        let activeName=this.editableTabsValue ;
        if (activeName === target) {
          tabs.forEach((tab,index) => {
            if (tab.departmentName === target) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.id;
              }
            }
          });
        }
        this.editableTabsValue = activeName;
        this.deptRoleList.forEach((elm,ind)=>{
          if(elm.departmentName==target){
            this.deptRoleList.splice(ind,1)
          }
        })
        this.deptRoleList = tabs.filter(tab => tab.departmentId !== target);
        if(this.deptRoleList.length==0){
          this.content.defaultDepartment='';
          this.editableTabsValue='';
        }else if(this.deptRoleList.length==1){
          this.setDefaultDept(this.deptRoleList[0].departmentId);
          // this.editableTabsValue=this.departments[0].name;
        }
      },
    }, 
};
</script>

<style lang="scss" scoped>
.el-date-editor{
  width: 100%;
}
.el-checkbox{
  display: inline-block !important;
  font-size: 14px;  
}
</style>